const escape = (value) => {
  const s = value == null ? '' : String(value);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const toCsv = (columns, rows) =>
  [columns.map((c) => escape(c.header)), ...rows.map((r) => columns.map((c) => escape(c.value(r))))]
    .map((line) => line.join(','))
    .join('\n');

export function downloadCsv(filename, columns, rows) {
  downloadBlob(filename, new Blob([toCsv(columns, rows)], { type: 'text/csv;charset=utf-8' }));
}

export function downloadBlob(filename, blob) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
